import React, { useEffect, useState } from 'react'
import styles from './overview.module.css'
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import Tooltip from './Tooltip';


function TopKips({ filterData, setGraphData }) {

    const { isLoading, error, sendReq: fetchData } = useHttp();
    const [cardData, setCardData] = useState({
        highPerVehicle: null,
        avgPerVehicle: null,
        lowPerVehicle: null,
        offlineVehicle: null,

    })

    let tooltipText = {
        highPerVehicle: "Vehicle with energy economy above 60 percentile within your fleet will be displayed in high performing.",
        avgPerVehicle: "Vehicle with energy economy above 40 to 60 percentile within your fleet will be displayed in average performing.",
        lowPerVehicle: "Vehicle with energy economy below 40 percentile within your fleet will be displayed in high performing.",
        offlineVehicle: "Vehicles which are not communicating with our server."
    }


    const displayData = [
        { label: 'High Performing Vehicles', key: "highPerVehicle", iconColor: '#48c774', icon: '/assets/img_Bus/Cesl Mileage Icon.png', trendDirection: 'up' },
        { label: 'Average Performing Vehicles', key: "avgPerVehicle", iconColor: '#ffc107', icon: '/assets/img_Bus/Cesl Mileage Icon.png', trendDirection: 'up' },
        { label: 'Low Performing Vehicles', key: "lowPerVehicle", iconColor: '#dc3545', icon: '/assets/img_Bus/Cesl Mileage Icon.png', trendDirection: 'down' },
        { label: 'Offline Vehicles', key: "offlineVehicle", iconColor: '#800080', icon: '/assets/img_Bus/Cesl Mileage Icon.png', trendDirection: 'down' }
    ]



    useEffect(() => {
        setCardData({
            highPerVehicle: null,
            avgPerVehicle: null,
            lowPerVehicle: null,
            offlineVehicle: null,
        })
        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi_overview/fleet_summary_overview_low_high_avg_vehicles`,
                body: {
                    filterdata: {
                        ...filterData,
                        CITY: filterData.CITY?.map(item => item?.value) || [],
                        DEPO: filterData.DEPO?.map(item => item?.value) || [],
                    }
                }
            },
            (res) => {
                let obj = {};
                if (Object.keys(res)?.length) {
                    obj.highPerVehicle = res?.high_performing?.count
                    obj.avgPerVehicle = res?.average_performing?.count
                    obj.lowPerVehicle = res?.low_performing?.count
                }
                else {
                    obj.highPerVehicle = null
                    obj.avgPerVehicle = null
                    obj.lowPerVehicle = null
                }
                setCardData(prev => ({ ...prev, ...obj }))
            }
        );

        fetchData(
            {
                url: API_URL_MAIN + `mileage_sarathi_overview/fleet_summary_overview_offline_vehicle`,
                body: {
                    filterdata: {
                        ...filterData,
                        CITY: filterData.CITY?.map(item => item?.value) || [],
                        DEPO: filterData.DEPO?.map(item => item?.value) || [],
                    }
                }
            },
            (res) => {

                let obj = {};
                obj.offlineVehicle = res?.offlineVehicle

                setCardData(prev => ({ ...prev, ...obj }))
            }
        );

    }, [filterData])


    useEffect(() => {
        setGraphData(prev => ({ ...prev, overviewCountSummary: cardData }))
    }, [cardData])

    return (
        <div>
            <div className="row mb-3">
                {displayData?.map((item, index) => (
                    <div key={index} className="col-12 col-md-3 mb-3">
                        <div
                            className={`card p-3 ${styles.kpi}`}
                        >

                            <div className="d-flex justify-content-between align-items-center my-auto">
                                <div className={`icon-out ${styles.icons}`}>
                                    <img
                                        src={item.icon}
                                        alt={item.label}
                                        style={{
                                            width: '25px',
                                            height: '25px',
                                            color: '48c774'
                                        }}
                                    />
                                </div>
                                {/* <div className=""> */}

                                <div>
                                    <div className="text-black fs-6 fw-bolder">
                                        {cardData?.[item.key] !== null ? cardData?.[item.key] : "--"}
                                    </div>
                                    <div >
                                        {item.label}
                                        <Tooltip text={tooltipText[item.key]}>
                                            <i
                                                className="fas fa-info-circle ms-2"
                                                style={{
                                                    color: '#83a4cf',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    border: '1px solid #358696',
                                                    borderRadius: '50%',
                                                    padding: '2px',
                                                    marginLeft: '5px'
                                                }}
                                            ></i>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div style={{ marginLeft: '10px' }}>
                                    <i
                                        className={`fas fa-arrow-trend-${item.trendDirection}`}
                                        style={{
                                            color: item.iconColor,
                                            fontSize: '16px'
                                        }}
                                    ></i>
                                </div>
                                {/* </div> */}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TopKips
